import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
`;
